export const AI_SUMMARY_CSV_FIELD_SUFFIX = ':ai-summary';

export type ParsedCsvFieldName =
  | { kind: 'ai-summary'; fieldName: string }
  | { kind: 'malformed-ai-summary'; fieldName: string }
  | { kind: 'untyped'; fieldName: string };

export function formatAiSummaryCsvFieldName(fieldName: string): string {
  return `${fieldName}${AI_SUMMARY_CSV_FIELD_SUFFIX}`;
}

export function parseCsvFieldName(fieldName: string): ParsedCsvFieldName {
  if (
    fieldName.endsWith(AI_SUMMARY_CSV_FIELD_SUFFIX) &&
    fieldName.length > AI_SUMMARY_CSV_FIELD_SUFFIX.length
  ) {
    return {
      kind: 'ai-summary',
      fieldName: fieldName.slice(0, -AI_SUMMARY_CSV_FIELD_SUFFIX.length)
    };
  }

  if (fieldName.includes(AI_SUMMARY_CSV_FIELD_SUFFIX)) {
    return { kind: 'malformed-ai-summary', fieldName };
  }

  return { kind: 'untyped', fieldName };
}
